import { notification } from 'antd';
import type { ArgsProps } from 'antd/es/notification';

type NotificationType = 'success' | 'info' | 'warning' | 'error';

interface NotificationOptions {
  message: string;
  description?: string;
  duration?: number;
  placement?: ArgsProps['placement'];
}

class NotificationService {
  private api = notification;

  success(options: NotificationOptions) {
    this.api.success({
      ...options,
      placement: options.placement || 'topRight',
      duration: options.duration || 4.5,
    });
  }

  error(options: NotificationOptions) {
    this.api.error({
      ...options,
      placement: options.placement || 'topRight',
      duration: options.duration || 4.5,
    });
  }

  info(options: NotificationOptions) {
    this.api.info({
      ...options,
      placement: options.placement || 'topRight',
      duration: options.duration || 4.5,
    });
  }

  warning(options: NotificationOptions) {
    this.api.warning({
      ...options,
      placement: options.placement || 'topRight',
      duration: options.duration || 4.5,
    });
  }

  open(type: NotificationType, options: NotificationOptions) {
    this.api[type]({
      ...options,
      placement: options.placement || 'topRight',
      duration: options.duration || 4.5,
    });
  }

  destroy() {
    this.api.destroy();
  }
}

export default new NotificationService();
